import React from 'react';


const PMCompanyName = (props) => {
	const { companyName, companyId } = props

	const openCompanyPage = () => {
		window.open(`/company/${companyId}`)
	}

	return (
		<>
			<span className='pm-company-name' onClick={openCompanyPage}>{companyName}</span>
		</>
	)
}

export default PMCompanyName; 